const formatCurrency = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return "—";
  }
  return numeric.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const formatNumber = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return "—";
  }
  return numeric.toFixed(2);
};

export default function OverviewStats({
  expected30DaysEarnings,
  netExposureValue,
  sharpeRatio,
  loading = false,
}) {
  const stats = [
    {
      value: expected30DaysEarnings,
      label: "Expected 30 Days Earnings",
      accent: "positive",
      currency: true,
    },
    {
      value: netExposureValue,
      label: "Net Exposure Value",
      accent:
        netExposureValue !== null && netExposureValue !== undefined && netExposureValue < 0
          ? "negative"
          : "",
      currency: true,
    },
    {
      value: sharpeRatio,
      label: "Sharpe Ratio",
    },
  ];

  return (
    <div className="stats-row">
      {stats.map((stat) => (
        <div key={stat.label} className="stat-card">
          <div className={`stat-value ${stat.accent || ""}`}>
            {loading ? (
              <span className="stat-value-placeholder" aria-hidden="true" />
            ) : stat.currency ? (
              <>
                <span className="dollar">$</span>
                {formatCurrency(stat.value)}
              </>
            ) : (
              formatNumber(stat.value)
            )}
          </div>
          <p className="stat-label">{stat.label}</p>
        </div>
      ))}
    </div>
  );
}
